export const TABLE_FILE_TYPE = {
  type: 'file' as const,
  wbObjectType: {type: 'table' as const, columnTypes: {}},
};
